export interface UserProps {
	id: string;
	name: string;
	image: string;
	bio: string;
	link?: LinkProps[];
}

export interface LinkProps {
	name: LinkName;
	url: string;
}

export enum LinkName {
	default = "link",
	facebook = "facebook",
	instagram = "instagram",
	twitter = "twitter"
}

export const DATA_LINK = {
	name: LinkName.facebook,
	url: "https://www.naver.com/"
};

export const DATA_USER = {
	id: "1",
	name: "윤태웅",
	image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=80",
	bio:
		"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Eaque, atque ratione. Est modi culpa ratione consectetur tempore, neque nobis doloribus illo eaque omnis enim minus rem id repudiandae obcaecati corporis!",
	link: [DATA_LINK, { ...DATA_LINK, name: LinkName.instagram }, { ...DATA_LINK, name: LinkName.twitter }, { ...DATA_LINK, name: LinkName.default }]
};

export function get_user(data: any) {
	let acf = data.acf;
	let user: any = {
		link: [
			{ name: "facebook", url: acf.link.facebook },
			{ name: "instagram", url: acf.link.instagram },
			{ name: "twitter", url: acf.link.twitter },
			{ name: "link", url: acf.link.link }
		]
	};

	if (acf.name) user = Object.assign(user, { name: acf.name });
	if (acf.bio) user = Object.assign(user, { bio: acf.bio });
	if (acf.photo) user = Object.assign(user, { image: acf.photo.url });

	return user;
}